// extracted by mini-css-extract-plugin
export default {"library__title":"Albums_library__title__VyJKJ"};